module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('hr', {
    staticClass: "c"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Satis multis sese emptores futuros libri professis, Georgius Nichols, Cantabrigiensis, opus emittet de parte gravi sed adhuc neglecta historiæ naturalis, cum titulo sequenti, videlicet:—")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("PROEMIUM.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Avunculo vero nuper mortuo, quum inter alios consanguineos testamenti ejus lectionem audiendi causa advenissem, erectis auribus verba talia sequentia accepi:—\"Quoniam persuasum habeo meum dilectum nepotem Homerum, longa et intima rerum angustarum domi experientia, aptissimum esse qui divitias tueatur, beneficenterque ac prudenter iis divinis creditis utatur,—ergo, motus hisce cogitationibus, exque amore meo in illum magno, do, legoque nepoti caro meo supranominato omnes singularesque istas possessiones nec ponderabiles nec computabiles meas quæ sequuntur, scilicet: quingentos libros quos mihi pigneravit dictus Homerus, anno lucis 1792, cum privilegio edendi et repetendi opus istud 'scientificum' (quod dicunt) suum, si sic elegerit. Tamen D. O. M. precor oculos Homeri nepotis mei ita aperiat eumque moveat, ut libros istos in bibliotheca unius e plurimis castellis suis Hispaniensibus tuto abscondat.\"")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Et mihi adhuc superstes est tota illa editio prima, quam quasi crepitaculum per quod dentes caninos dentibam retineo.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('hr', {
    staticClass: "c"
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "c"
  }), _vm._v(" "), _c('p', {
    staticClass: "head3"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("MELIBŒUS-HIPPONAX.")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('b', {
    staticClass: "calibre15"
  }, [_vm._v("THE")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('big', {
    staticClass: "calibre4"
  }, [_c('big', {
    staticClass: "c2"
  }, [_vm._v("BIGLOW PAPERS,")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("EDITED,")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "head4"
  }, [_c('big', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("By")]), _vm._v(" HOMER WILBUR, A.M.")])], 1), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('hr', {
    staticClass: "c"
  }), _vm._v(" "), _vm._m(16)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "pgepubid00029"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "NOTICES_OF_AN_INDEPENDENT_PRESS"
    }
  }), _vm._v("NOTICES OF AN INDEPENDENT PRESS.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hw"
  }, [_c('p', {
    staticClass: "calibre9"
  }, [_vm._v("[I have observed, reader, (bene- or male-volent, as it may happen,) that it is customary to append to the second editions of books, and to the second works of authors, short sentences commendatory of the first, under the title of "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Notices of the Press")]), _vm._v(". These, I have been given to understand, are procurable at certain established rates, payment being made either in money or advertising patronage by the publisher, or by an adequate outlay of servility on the part of the author. Considering these things with myself, and also that such notices are neither intended, nor generally believed, to convey any real opinions, being a purely ceremonial accompaniment of literature, and resembling certificates to the virtues of various morbiferal panaceas, I conceived that it would be not only more economical to prepare a sufficient number of such myself, but also more immediately subservient to the end in view, to prefix them to this our primary edition, rather than await the contingency of a second, when they would seem to be of small utility. To delay attaching the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("bobs")]), _vm._v(" until the second attempt at flying the kite would indicate but a slender experience in that useful art. Neither has it escaped my notice, nor failed to afford me matter of reflection, that, when a circus or a caravan is about to visit Jaalam, the initial step is to send forward large and highly ornamented bills of performance to be hung in the bar-room and the post-office. These having been sufficiently"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxx",
      "title": "[Pg xxx]"
    }
  }), _vm._v(" gazed at, and beginning to lose their attractiveness except for the flies, and, truly, the boys also, (in whom I find it impossible to repress, even during school-hours, certain oral and telegraphic correspondences concerning the expected show,) upon some fine morning the band enters in a gaily-painted waggon, or triumphal chariot, and with noisy advertisement, by means of brass, wood, and sheepskin, makes the circuit of our startled village-streets. Then, as the exciting sounds draw nearer and nearer, do I desiderate those eyes of Aristarchus, \"whose looks were as a breeching to a boy.\" Then do I perceive, with vain regret of wasted opportunities, the advantage of a pancratic or pantechnic education, since he is most reverenced by my little subjects who can throw the cleanest summerset, or walk most securely upon the revolving cask. The story of the Pied Piper becomes for the first time credible to me, (albeit confirmed by the Hameliners dating their legal instruments from the period of his exit,) as I behold how those strains, without pretence of magical potency, bewitch the pupillary legs, nor leave to the pedagogic an entire self-control. For these reasons, lest my kingly prerogative should suffer diminution, I prorogue my restless commons, whom I also follow into the street, chiefly lest some mischief may chance befall them. After the manner of such a band, I send forward the following notices of domestic manufacture, to make brazen proclamation, not unconscious of the advantage which will accrue, if our little craft, "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("cymbula sutilis")]), _vm._v(", shall seem to leave port with a clipping breeze, and to carry, in nautical phrase, a bone in her mouth. Nevertheless, I have chosen, as being more equitable, to prepare some also sufficiently objurgatory, that readers of every taste may find a dish to their palate. I have modelled them upon actually existing specimens, preserved in my own cabinet of natural curiosities. One, in particular, I had copied with tolerable exactness from a notice of one of"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxi",
      "title": "[Pg xxxi]"
    }
  }), _vm._v(" my own discourses, which, from its superior tone and appearance of vast experience, I concluded to have been written by a man at least three hundred years of age, though I recollected no existing instance of such antediluvian longevity. Nevertheless, I afterwards discovered the author to be a young gentleman preparing for the ministry under the direction of one of my brethren in a neighbouring town, and whom I had once instinctively corrected in a Latin quantity. But this I have been forced to omit, from its too great length.—H. W.]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Universal Littery Universe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Full of passages which rivet the attention of the reader.... Under a rustic garb, sentiments are conveyed which should be committed to the memory and engraven on the heart of every moral and social being.... We consider this a "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("unique")]), _vm._v(" performance.... We hope to see it soon introduced into our common schools.... Mr. Wilbur has performed his duties as editor with excellent taste and judgment.... This is a vein which we hope to see successfully prosecuted.... We hail the appearance of this work as a long stride toward the formation of a purely aboriginal, indigenous, native, and American literature. We rejoice to meet with an author national enough to break away from the slavish deference, too common among us, to English grammar and orthography.... Where all is so good, we are at a loss how to make extracts.... On the whole, we may call it a volume which no library, pretending to entire completeness, should fail to place upon its shelves.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Higginbottomopolis Snapping-turtle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("A collection of the merest balderdash and doggerel that it was ever our bad fortune to lay eyes on. The author is a vulgar buffoon, and the editor a talkative, tedious old fool. We use strong language, but should any of our readers peruse the book, (from which calamity Heaven preserve them,) they will find reasons for it thick as the leaves of Vallumbrozer, or, to use"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxii",
      "title": "[Pg xxxii]"
    }
  }), _vm._v(" a still more expressive comparison, as the combined heads of author and editor. The work is wretchedly got up.... We should like to know how much "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("British gold")]), _vm._v(" was pocketed by this libeller of our country and her purest patriots.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Oldfogrumville Mentor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("We have not had time to do more than glance through this handsomely printed volume, but the name of its respectable editor, the Rev. Mr. Wilbur, of Jaalam, will afford a sufficient guaranty for the worth of its contents.... The paper is white, the type clear, and the volume of a convenient and attractive size.... In reading this elegantly executed work, it has seemed to us that a passage or two might have been retrenched with advantage, and that the general style of diction was susceptible of a higher polish.... On the whole, we may safely leave the ungrateful task of criticism to the reader. We will barely suggest, that in volumes intended, as this is, for the illustration of a provincial dialect and turns of expression, a dash of humour or satire might be thrown in with advantage.... The work is admirably got up.... This work will form an appropriate ornament to the centre-table. It is beautifully printed, on paper of an excellent quality.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Dekay Bulwark.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("We should be wanting in our duty as the conductor of that tremendous engine, a public press, as an American, and as a man, did we allow such an opportunity as is presented to us by \"The Biglow Papers\" to pass by without entering our earnest protest against such attempts (now, alas! too common) at demoralizing the public sentiment. Under a wretched mask of stupid drollery, slavery, war, the social glass, and, in short, all the valuable and time-honoured institutions justly dear to our common humanity and especially to republicans, are made the butt of coarse and senseless ribaldry by this low-minded scribbler. It is time that the respectable and religious portion of our community should be aroused to the alarming inroads of foreign Jacobinism, sansculottism, and infidelity. It is a fearful proof of the wide-spread nature of this contagion, that these secret stabs at religion and virtue are given from under the cloak ("), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("credite, posteri!")]), _vm._v(") of a clergyman. It is a mournful spectacle indeed to the patriot and Christian to see liberality and new ideas (falsely so called,—they are"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxiii",
      "title": "[Pg xxxiii]"
    }
  }), _vm._v(" as old as Eden) invading the sacred precincts of the pulpit.... On the whole, we consider this volume as one of the first shocking results which we predicted would spring out of the late French \"Revolution\"(!).")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Bungtown Copper and Comprehensive Tocsin (a tryweakly family journal).")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Altogether an admirable work.... Full of humour, boisterous, but delicate,—of wit withering and scorching, yet combined with a pathos cool as morning dew,—of satire ponderous as the mace of Richard, yet keen as the scymitar of Saladin.... A work full of \"mountain-mirth,\" mischievous as Puck and lightsome as Ariel.... We know not whether to admire most the genial, fresh, and discursive concinnity of the author, or his playful fancy, weird imagination, and compass of style, at once both objective and subjective.... We might indulge in some criticisms, but, were the author other than he is, he would be a different being. As it is, he has a wonderful "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("pose")]), _vm._v(", which flits from flower to flower, and bears the reader irresistibly along on its eagle pinions (like Ganymede) to the \"highest heaven of invention.\" ... We love a book so purely objective.... Many of his pictures of natural scenery have an extraordinary subjective clearness and fidelity.... In fine, we consider this as one of the most extraordinary volumes of this or any age. We know of no English author who could have written it. It is a work to which the proud genius of our country, standing with one foot on the Aroostook and the other on the Rio Grande, and holding up the star-spangled banner amid the wreck of matter and the crush of worlds, may point with bewildering scorn of the punier efforts of enslaved Europe.... We hope soon to encounter our author among those higher walks of literature in which he is evidently capable of achieving enduring fame. Already we should be inclined to assign him a high position in the bright galaxy of our American bards.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Saltriver Pilot and Flag of Freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("A volume in bad grammar and worse taste.... While the pieces here collected were confined to their appropriate sphere in the corners of obscure newspapers, we considered them wholly beneath contempt, but, as the author has chosen to come forward in this public manner, he must expect"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxiv",
      "title": "[Pg xxxiv]"
    }
  }), _vm._v(" the lash he so richly merits.... Contemptible slanders.... Vilest Billingsgate.... Has raked all the gutters of our language.... The most pure, upright, and consistent politicians not safe from his malignant venom.... General Cushing comes in for a share of his vile calumnies.... The "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Reverend")]), _vm._v(" Homer Wilbur is a disgrace to his cloth....")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the World-Harmonic-Æolian-Attachment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Speech is silver: silence is golden. No utterance more Orphic than this. While, therefore, as highest author, we reverence him whose works continue heroically unwritten, we have also our hopeful word for those who with pen (from wing of goose loud-cackling, or seraph God-commissioned) record the thing that is revealed.... Under mask of quaintest irony, we detect here the deep, storm-tost (nigh shipwracked) soul, thunder-scarred, semiarticulate, but ever climbing hopefully toward the peaceful summits of an Infinite Sorrow.... Yes, thou poor, forlorn Hosea, with Hebrew fire-flaming soul in thee, for thee also this life of ours has not been without its aspect of heavenliest pity and laughingest mirth. Conceivable enough! Through coarse Thersites-cloak, we have revelation of the heart, wild-glowing, world-clasping, that is in him. Bravely he grapples with the life-problem as it presents itself to him, uncombed, shaggy, careless of the \"nicer proprieties,\" inexpert of \"elegant diction,\" yet with voice audible enough to whoso hath ears, up there on the gravelly side-hills, or down on the splashy, Indiarubber-like salt-marshes of native Jaalam. To this soul also the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Necessity of Creating")]), _vm._v(" somewhat has unveiled its awful front. If not Œdipuses and Electras and Alcestises, then in God's name Birdofredum Sawins! These also shall get born into the world, and filch (if so need) a Zingali subsistence therein, these lank, omnivorous Yankees of his. He shall paint the Seen, since the Unseen will not sit to him. Yet in him also are Nibelungen-lays, and Iliads, and Ulysses-wanderings, and Divine Comedies,—if only once he could come at them! Therein lies much, nay all; for what truly is this which we name "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("All")]), _vm._v(", but that which we do "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("not")]), _vm._v(" possess?... Glimpses also are given us of an old father Ezekiel, not without paternal pride, as is the wont of such. A brown, parchment-hided old man of the geoponic or bucolic species, gray-eyed, we fancy, "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("queued")]), _vm._v(" perhaps, with much weather-cunning and plentiful September-gale memories, bidding fair in good time to become the Oldest Inhabitant. After such hasty apparition, he vanishes and is seen no more.... Of \"Rev. Homer Wilbur, A. M., Pastor of the First"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxv",
      "title": "[Pg xxxv]"
    }
  }), _vm._v(" Church in Jaalam,\" we have small care to speak here. Spare touch in him of his Melesigenes namesake, save, haply, the—blindness! A tolerably caliginose, nephelegeretous elderly gentleman, with infinite faculty of sermonizing, muscularized by long practice, and excellent digestive apparatus, and, for the rest, well-meaning enough, and with small private illuminations (somewhat tallowy, it is to be feared) of his own. To him, there, \"Pastor of the First Church in Jaalam,\" our Hosea presents himself as a quiet inexplicable Sphinx-riddle. A rich, poverty of Latin and Greek,—so far is clear enough, even to eyes peering myopic through horn-lensed editorial spectacles,—but naught farther? O purblind, well-meaning, altogether fuscous Melesigenes-Wilbur, there are things in him incommunicable by stroke of birch! Did it ever enter that old bewildered head of thine that there was the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Possibility of the Infinite")]), _vm._v(" in him? To thee, quite wingless (and even featherless) biped, has not so much even as a dream of wings ever come? \"Talented young parishioner\"? Among the Arts whereof thou art "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Magister")]), _vm._v(", does that of "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("seeing")]), _vm._v(" happen to be one? Unhappy "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Artium Magister")]), _vm._v("! Somehow a Nemean lion, fulvous, torrid-eyed, dry-nursed in broad-howling sand-wildernesses of a sufficiently rare spirit-Libya (it may be supposed) has got whelped among the sheep. Already he stands wild-glaring, with feet clutching the ground as with oak-roots, gathering for a Remus-spring over the walls of thy little fold. In Heaven's name, go not near him with that flybite crook of thine! In good time, thou painful preacher, thou wilt go to the appointed place of departed Artillery-Election Sermons, Right-Hands of Fellowship, and Results of Councils, gathered to thy spiritual fathers with much Latin of the Epitaphial sort; thou, too, shalt have thy reward; but on him the Eumenides have looked, not Xantippes of the pit, snake-tressed, finger-threatening, but radiantly calm as on antique gems; for him paws impatient the winged courser of the gods, champing unwelcome bit: him the starry deeps, the empyrean glooms, and far-flashing splendors await.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Onion Grove Phœnix.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("A talented young townsman of ours, recently returned from a Continental tour, and who is already favourably known to our readers by his sprightly letters from abroad which have graced our columns, called at our office yesterday. We learn from him, that, having enjoyed the distinguished"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxvi",
      "title": "[Pg xxxvi]"
    }
  }), _vm._v(" privilege, while in Germany, of an introduction to the celebrated Von Humbug, he took the opportunity to present that eminent man with a copy of the \"Biglow Papers.\" The next morning he received the following note, which he has kindly furnished us for publication. We prefer to print "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("verbatim")]), _vm._v(", knowing that our readers will readily forgive the few errors into which the illustrious writer has fallen, through ignorance of our language.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("\""), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("High-Worthy Mister!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("\"I shall also now especially happy starve, because I have more or less a work of one those aboriginal Red-Men seen in which have I so deaf an interest ever taken fullworthy on the self shelf with our Gottsched to be upset.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("\"Pardon my in the English-speech unpractice!")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("\""), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Von Humbug.")]), _vm._v("\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("He also sent with the above note a copy of his famous work on \"Cosmetics,\" to be presented to Mr. Biglow; but this was taken from our friend by the English custom-house officers, probably through a petty national spite. No doubt, it has by this time found its way into the British Museum. We trust this outrage will be exposed in all our American papers. We shall do our best to bring it to the notice of the State Department. Our numerous readers will share in the pleasure we experience at seeing our young and vigorous national literature thus encouragingly patted on the head by this venerable and world-renowned German. We love to see these reciprocations of good-feeling between the different branches of the great Anglo-Saxon race.")]), _vm._v(" "), _c('hr', {
    staticClass: "c1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("From the Jaalam Independent Blunderbuss.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("... But, while we lament to see our young townsman thus mingling in the heated contests of party politics, we think we detect in him the presence of talents which, if properly directed, might give an innocent pleasure to many. As a proof that he is competent to the production of other kinds of poetry, we copy for our readers a short fragment of a pastoral by him, the manuscript of which was loaned us by a friend. The title of it is \"The Courtin'.\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxvii",
      "title": "[Pg xxxvii]"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpoem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Zekle crep' up, quite unbeknown,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("An' peeked in thru the winder,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("An' there sot Huldy all alone,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("'ith no one nigh to hender."), _c('br', {
    staticClass: "calibre11"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Agin' the chimbly crooknecks hung,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("An' in amongst 'em rusted"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The ole queen's arm thet gran'ther Young"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Fetched back frum Concord busted."), _c('br', {
    staticClass: "calibre11"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The wannut logs shot sparkles out"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Towards the pootiest, bless her!"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("An' leetle fires danced all about"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("The chiny on the dresser."), _c('br', {
    staticClass: "calibre11"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The very room, coz she wuz in,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Looked warm frum floor to ceilin',"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("An' she looked full ez rosy agin"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Ez th' apples she wuz peelin'."), _c('br', {
    staticClass: "calibre11"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("She heerd a foot an' knowed it, tu,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Araspin' on the scraper,—"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("All ways to once her feelins flew"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Like sparks in burnt-up paper."), _c('br', {
    staticClass: "calibre11"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("He kin' o' l'itered on the mat,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Some doubtfle o' the seekle;"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("His heart kep' goin' pitypat,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("But hern went pity Zekle."), _c('br', {
    staticClass: "calibre11"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i1"
  }, [_vm._v("... ... ... ... ... ... ... ..."), _c('br', {
    staticClass: "calibre11"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxviii",
      "title": "[Pg xxxviii]"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Conatus ad Delineationem naturalem nonnihil perfectiorem Scarabæi Bombilatoris, vulgo dicti")]), _vm._v(" "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Humbug")]), _vm._v(", ab "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Homero Wilbur")]), _vm._v(", Artium Magistro, Societatis historico-naturalis Jaallamensis Præside, (Secretario, Socioque (eheu!) singulo,) multarumque aliarum Societatum eruditarum (sive ineruditarum) tam domesticarum quam transmarinarum Socio—forsitan futuro.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lectori Benevolo S.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Toga scholastica nondum deposita, quum systemata varia entomologica, a viris ejus scientiæ cultoribus studiosissimis summa diligentia ædificata, penitus indagâssem, non fuit quin luctuose omnibus in iis, quamvis aliter laude dignissimis, hiatum magni momenti perciperem. Tunc, nescio quo motu superiore impulsus, aut qua captus dulcedine operis, ad eum implendum (Curtius alter) me solemniter devovi. Nec ab isto labore, "), _c('span', {
    attrs: {
      "title": "daimoniôs"
    }
  }, [_vm._v("δαιμονίως")]), _vm._v(" imposito, abstinui antequam tractatulum sufficienter inconcinnum lingua vernacula perfeceram. Inde, juveniliter tumefactus, et barathro ineptiæ "), _c('span', {
    attrs: {
      "title": "tôn bibliopôlôn"
    }
  }, [_vm._v("τῶν βιβλιοπωλῶν")]), _vm._v(" (necnon \"Publici Legentis\") nusquam explorato, me composuisse quod quasi placentas præfervidas (ut sic dicam) homines"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxxix",
      "title": "[Pg xxxix]"
    }
  }), _vm._v(" ingurgitarent credidi. Sed, quum huic et alii bibliopolæ MSS. mea submisissem et nihil solidius responsione valde negativa in Musæum meum retulissem, horror ingens atque misericordia, ob crassitudinem Lambertianam in cerebris homunculorum istius muneris cœlesti quadam ira infixam, me invasere. Extemplo mei solius impensis librum edere decrevi, nihil omnino dubitans quin \"Mundus Scientificus\" (ut aiunt) crumenam meam ampliter repleret. Nullam, attamen, ex agro illo meo parvulo segetem demessui, præter gaudium vacuum bene de Republica merendi. Iste panis meus pretiosus super aquas literarias fæculentas præfidenter jactus, quasi Harpyiarum quarundam (scilicet bibliopolarum istorum facinorosorum supradictorum) tactu rancidus, intra perpaucos dies mihi domum rediit. Et, quum ipse tali victu ali non tolerarem, primum in mentem venit pistori (typographo nempe) nihilominus solvendum esse. Animum non idcirco demisi, imo æque ac pueri naviculas suas penes se lino retinent (eo ut e recto cursu delapsas ad ripam retrahant), sic ego Argô meam chartaceam fluctibus laborantem a quæsitu velleris aurei, ipse potius tonsus pelleque exutus, mente solida revocavi. Metaphoram ut mutem, "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("boomarangam")]), _vm._v(" meam a scopo aberrantem retraxi, dum majore vi, occasione ministrante, adversus Fortunam intorquerem. Ast mihi, talia volventi, et, sicut Saturnus ille "), _c('span', {
    attrs: {
      "title": "paidoboros"
    }
  }, [_vm._v("παιδοβόρος")]), _vm._v(", liberos intellectus mei depascere fidenti, casus miserandus, nec antea inauditus, supervenit. Nam, ut ferunt Scythas pietatis causa et parsimoniæ, parentes suos mortuos devorâsse, sic filius hic meus primogenitus, Scythis ipsis minus mansuetus, patrem vivum totum et calcitrantem exsorbere enixus est. Nec tamen hac de causa sobolem meam esurientem exheredavi. Sed famem istam pro valido testimonio virilitatis roborisque potius habui, cibumque ad eam satiandam salva paterna mea carne, petii. Et quia bilem illam scaturientem ad æs etiam concoquendum idoneam"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xl",
      "title": "[Pg xl]"
    }
  }), _vm._v(" esse estimabam, unde æs alienum, ut minoris pretii, haberem, circumspexi. Rebus ita se habentibus, ab avunculo meo Johanne Doolittle, Armigero, impetravi ut pecunias necessarias suppeditaret, ne opus esset mihi universitatem relinquendi antequam ad gradum primum in artibus pervenissem. Tunc ego, salvum facere patronum meum munificum maxime cupiens, omnes libros primæ editionis operis mei non venditos una cum privilegio in omne ævum ejusdem imprimendi et edendi avunculo meo dicto pigneravi. Ex illo die, atro lapide notando, curæ vociferantes familiæ singulis annis crescentis eo usque insultabant ut nunquam tam carum pignus e vinculis istis aheneis solvere possem.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("His verbis (vix credibilibus) auditis, cor meum in pectore exsultavit. Deinde, quoniam tractatus Anglice scriptus spem auctoris fefellerat, quippe quum studium Historiæ Naturalis in Republica nostra inter factionis strepitum languescat, Latine versum edere statui, et eo potius quia nescio quomodo disciplina"), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xli",
      "title": "[Pg xli]"
    }
  }), _vm._v(" academica et duo diplomata proficiant, nisi quod peritos linguarum omnino mortuarum (et damnandarum, ut dicebat iste "), _c('span', {
    attrs: {
      "title": "panourgos"
    }
  }, [_vm._v("πανοῦργος")]), _vm._v(" Gulielmus Cobbett) nos faciant.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "head2"
  }, [_vm._v("OPERIS SPECIMEN.")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("("), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Ad exemplum Johannis Physiophili speciminis Monachologiæ.")]), _vm._v(")"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("\n    12. S. B. "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Militaris")]), _vm._v(", "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Wilbur")]), _vm._v(". "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Carnifex")]), _vm._v(", "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Jablonsk")]), _vm._v(". "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Profanus")]), _vm._v(", "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Desfont")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("[Male hancce speciem "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Cyclopem")]), _vm._v(", Fabricius vocat, ut qui singulo oculo ad quod sui interest distinguitur. Melius vero Isaacus Outis nullum inter S. milit. S. que Belzebul (Fabric. 152) discrimen esse defendit.]")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Habitat civitat. Americ. austral.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Aureis lineis splendidus; plerumque tamen sordidus, utpote lanienas valde frequentans, fœtore sanguinis allectus. Amat quoque insuper septa apricari, neque inde, nisi maxima conatione, detruditur. "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Candidatus")]), _vm._v(" ergo populariter vocatus. Caput cristam quasi pennarum ostendit. Pro cibo vaccam publicam callide mulget; abdomen enorme; facultas suctus haud facile estimanda. Otiosus, fatuus; ferox nihilominus, semperque dimicare paratus. Tortuose repit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Capite sæpe maxima cum cura dissecto, ne illud rudimentum etiam cerebri commune omnibus prope insectis detegere poteram.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Unam de hoc S. milit. rem singularem notavi; nam S. Guineeus. (Fabric. 143) servos facit, et idcirco a multis summa in reverentia habitus, quasi scintillas rationis pæne humanæ demonstrans.")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("24. S. B. "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Criticus")]), _vm._v(", "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Wilbur")]), _vm._v(". "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Zoilus")]), _vm._v(", "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Fabric")]), _vm._v(". "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Pygmæus")]), _vm._v(", "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Carlsen")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("[Stultissime Johannes Stryx cum S. punctato (Fabric. 64-109) confundit. Specimina quam plurima scrutationi microscopicæ subjeci, nunquam tamen unum ulla indicia puncti cujusvis prorsus ostendentem inveni.]")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Præcipue formidolosus, insectatusque, in proxima rima anonyma sese abscondit, "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("we, we")]), _vm._v(", creberrime stridens. Ineptus, segnipes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_vm._v("Habitat ubique gentium; in sicco; nidum suum terebratione indefessa ædificans. Cibus. Libros depascit; siccos præcipue seligens, et forte succidum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00042"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "THE_BIGLOW_PAPERS"
    }
  }), _vm._v("THE BIGLOW PAPERS.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "head4"
  }, [_vm._v("WITH AN INTRODUCTION, NOTES, GLOSSARY,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\n  AND COPIOUS INDEX,")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PASTOR OF THE FIRST CHURCH IN JAALAM, AND (PROSPECTIVE) MEMBER OF"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("\n  MANY LITERARY, LEARNED, AND SCIENTIFIC SOCIETIES,"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("\n  ("), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("for which see page")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0004.htm#Page_xlvii"
    }
  }, [_vm._v("xlvii")]), _vm._v(".)")]), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpoem1"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The ploughman's whistle, or the trivial flute,"), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Finds more respect than great Apollo's lute."), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Quarles's Emblems")]), _vm._v(", B. II. E. 8."), _c('br', {
    staticClass: "calibre11"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpoem1"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Margaritas, munde porcine, calcâsti: en, siliquas accipe."), _c('br', {
    staticClass: "calibre11"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Jaa. Car. Fil. ad Pub. Leg.")]), _vm._v(" § 1."), _c('br', {
    staticClass: "calibre11"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xlvii",
      "title": "[Pg xlvii]"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b660674e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0004.vue
// module id = 66
// module chunks = 0